const de = {
  tools_actions: {
    hotel_info: "Ich suche Informationen zum Hotel...",
    accommodation_info: "Ich suche Informationen zum Hotel...",
    accomodation_info: "Ich suche Informationen zum Hotel...",
    get_destination_info: "Ich suche Aktivitäten in der Umgebung...",
    get_guest_information: "Ich prüfe Ihre Reservierung...",
    book_hotel_service_or_get_availability: "Ich prüfe die Verfügbarkeit des Services...",
    list_accomodations: "Ich lade die Unterkünfte...",
    set_accomodation: "Ich lade die Unterkunft...",
    list_accommodations: "Ich lade die Unterkünfte...",
    set_accommodation: "Ich lade die Unterkunft...",
    destination_info: "Ich suche Aktivitäten in der Umgebung...",
    show_map: "Ich erstelle die Karte...",
    consult_rules: "Ich prüfe die Hausregeln...",
    notify_reception: "Ich informiere die Rezeption...",
    save_self_declared_stay: "Ich speichere Ihren Aufenthalt...",
    generate_quote_for_single_room_longstay_rooms: "Ich erstelle ein Angebot...",
    generate_quote_for_multiple_rooms_longstay: "Ich erstelle ein Angebot...",
    hotel_info_iodah:
      "Perfekt, ich hole die Information ein und bin gleich für Sie da...",
    generate_quote_for_rooms: "Ich erstelle ein Angebot...",
    check_availability: "Ich prüfe die Verfügbarkeit...",
    print_calendar: "Ich prüfe den Kalender...",
    nearby_restaurants: "Ich suche Restaurants in der Nähe...",
    nearby_attractions: "Ich suche Sehenswürdigkeiten in der Nähe...",
    human_handoff: "Ich verbinde Sie mit einem Mitarbeiter...",
    tool_search_offers_by_request: "Ich suche die besten Angebote für Sie...",
    tool_search_hotels_by_request: "Ich suche die besten Hotels für Sie...",
  },
  tool_status_sequences: {
    generate_quote_for_rooms: [
      "Ich prüfe die Verfügbarkeit für Ihre Reisedaten…",
      "Ich vergleiche Zimmer und Preise…",
      "Ich erstelle Ihr Angebot…",
    ],
    generate_quote_for_single_room_longstay_rooms: [
      "Ich prüfe die Verfügbarkeit für Ihre Reisedaten…",
      "Ich vergleiche Zimmer und Preise…",
      "Ich erstelle Ihr Angebot…",
    ],
    generate_quote_for_multiple_rooms_longstay: [
      "Ich prüfe die Verfügbarkeit für Ihre Reisedaten…",
      "Ich vergleiche Zimmer und Preise…",
      "Ich erstelle Ihr Angebot…",
    ],
    check_availability: [
      "Ich prüfe den Kalender…",
      "Ich kontrolliere die Verfügbarkeit…",
      "Nur noch einen Moment…",
    ],
    hotel_info: [
      "Ich sehe die Hotelinformationen durch…",
      "Ich hole die Details…",
      "Ich bereite die Antwort vor…",
    ],
    accommodation_info: [
      "Ich sehe die Hotelinformationen durch…",
      "Ich hole die Details…",
      "Ich bereite die Antwort vor…",
    ],
    accomodation_info: [
      "Ich sehe die Hotelinformationen durch…",
      "Ich hole die Details…",
      "Ich bereite die Antwort vor…",
    ],
    get_destination_info: [
      "Ich erkunde die Umgebung…",
      "Ich wähle die besten Tipps aus…",
      "Fast fertig…",
    ],
    nearby_restaurants: [
      "Ich suche Restaurants in der Nähe…",
      "Ich wähle die passendsten aus…",
      "Fast fertig…",
    ],
    nearby_attractions: [
      "Ich suche Aktivitäten in der Umgebung…",
      "Ich wähle das Beste aus…",
      "Fast fertig…",
    ],
    get_guest_information: [
      "Ich rufe Ihre Reservierung ab…",
      "Ich prüfe die Details Ihres Aufenthalts…",
      "Nur noch einen Moment…",
    ],
    book_hotel_service_or_get_availability: [
      "Ich prüfe die Verfügbarkeit des Services…",
      "Ich sehe die Zeiten nach…",
      "Nur noch einen Moment…",
    ],
    print_calendar: ["Ich öffne den Kalender…", "Ich prüfe die Termine…"],
    list_accomodations: ["Ich lade die Unterkünfte…", "Ich stelle die Liste zusammen…"],
    set_accomodation: ["Ich öffne die Unterkunft…", "Ich hole die Informationen…"],
    list_accommodations: ["Ich lade die Unterkünfte…", "Ich stelle die Liste zusammen…"],
    set_accommodation: ["Ich öffne die Unterkunft…", "Ich hole die Informationen…"],
    destination_info: [
      "Ich erkunde die Umgebung…",
      "Ich wähle die besten Tipps aus…",
      "Fast fertig…",
    ],
    show_map: ["Ich suche die Orte auf der Karte…", "Ich erstelle die Route…"],
    consult_rules: ["Ich prüfe die Hausregeln…", "Ich kontrolliere die Bedingungen…"],
    notify_reception: ["Ich informiere die Rezeption…", "Ich leite die Anfrage weiter…"],
    save_self_declared_stay: ["Ich speichere Ihren Aufenthalt…", "Ich verknüpfe die Buchung…"],
    human_handoff: ["Ich informiere die Rezeption…", "Ich übergebe das Gespräch…"],
    tool_search_offers_by_request: [
      "Ich suche die besten Angebote für Sie…",
      "Ich vergleiche die Optionen…",
      "Fast fertig…",
    ],
    tool_search_hotels_by_request: [
      "Ich suche die passendsten Hotels…",
      "Ich vergleiche die Optionen…",
      "Fast fertig…",
    ],
  },
  status_thinking: ["Einen Moment…", "Ich denke nach…", "Nur noch einen Moment…"],
  status_generic: ["Fast fertig…", "Nur noch einen Moment…"],
  tooltip_sentences: [
    "Möchten Sie ein schnelles Angebot? 😊",
    "Möchten Sie Infos zum Hotel? 😊",
  ],
  tooltip_sentences_iodah: [
    "Willkommen bei The First Hotels.",
    "Wie kann ich Ihnen heute helfen?",
  ],
  // Variant B of the open-rate experiment: two clickable teaser pills ·
  // a fixed high-intent hook on top, a rotating multi-intent pill below.
  // A click opens the chat and sends the pill as the guest message.
  // Hotels can override these from the backoffice (per locale); these are
  // the defaults when no configuration is present.
  welcome_message_default:
    "Hallo! 👋 Ich bin der virtuelle Assistent des Hotels. Ich prüfe Verfügbarkeiten und Preise und beantworte alle Fragen zu Ihrem Aufenthalt. Wie kann ich Ihnen helfen?",
  teaser_pill_fixed: "Angebot in 30 Sekunden ⚡",
  teaser_pills_rotating: [
    "Gibt es freie Zimmer für meine Reisedaten? 📅",
    "Welche Zimmer haben Sie? 🛏️",
    "Wie ist das Frühstück? 🥐",
  ],
  quote_pills: {
    alone: "Nur ich",
    alone_message: "Nur ich, eine Person",
    party: "Wir sind {n}",
    party_message: "Wir sind {n} Personen",
  },
  replies_in_realtime: "Antworten in Echtzeit",
  ai_disclosure: "Ich bin der KI-Assistent der Unterkunft. Sie können jederzeit nach einem Mitarbeiter fragen.",
  assistant_default_name: "Name des Assistenten",
  powered_by: "Bereitgestellt von",
  type_a_message: "Nachricht schreiben...",
  speak_with_operator: "Mit einem Mitarbeiter sprechen",
  // "Call us" card in the welcome message (VoiceCallCard).
  voice_call: {
    title: "Rufen Sie uns an",
    subtitle: "Unser Sprachassistent antwortet sofort",
    badge: "Neu",
    call: "Anrufen",
    copy: "Nummer kopieren",
    copied: "Nummer kopiert",
  },
  voice_panel: {
    status_idle: "Bereit",
    status_connecting: "Stimme wird vorbereitet...",
    status_listening: "Ich höre zu",
    status_error: "Verbindungsfehler",
    status_warming: "Stimme wird aufgewärmt...",
    transcript_empty: "Sag etwas…",
    end_call: "Anruf beenden",
    start_call: "Sprachanruf starten",
    start_mode: "Sprachmodus starten",
    stop_mode: "Sprachmodus beenden",
  },
  continue_on_whatsapp: "Auf WhatsApp fortfahren",
  whatsapp_handoff_prefill:
    "Hallo! Ich habe auf Ihrer Website mit dem Assistenten geschrieben und möchte hier weitermachen.",
  request_quote: "Angebot anfordern",
  map_directions: "In Maps öffnen",
  handoff_form: {
    title: "Kontaktieren Sie uns",
    desc: "Hinterlassen Sie uns Ihre Kontaktdaten und unser Team meldet sich schnellstmöglich bei Ihnen.",
    firstname: "Vorname",
    lastname: "Nachname",
    email: "E-Mail",
    phone: "Telefon",
    phone_hint: "Darüber erreichen wir Sie, auch über WhatsApp.",
    phone_search: "Land suchen",
    submit: "Anfrage senden",
    success:
      "Vielen Dank! Wir haben Ihre Daten erhalten und melden uns schnellstmöglich bei Ihnen. 😊",
    handoff_email_success:
      "Wir antworten Ihnen per E-Mail an {email}. Sie können diese Seite schließen.",
    submit_error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es in Kürze erneut.",
    firstname_error: "Bitte geben Sie Ihren Vornamen ein.",
    lastname_error: "Bitte geben Sie Ihren Nachnamen ein.",
    email_error: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    phone_error: "Bitte geben Sie eine gültige Telefonnummer ein.",
    close_aria_label: "Schließen",
  },
  error_generic: "Etwas ist schiefgelaufen. Bitte versuchen Sie es später noch einmal.",
  delete_chat_aria_label: "Chat löschen",
  close_aria_label: "Chat schließen",
  send_aria_label: "Nachricht senden",
  chat_widget_aria_label: "Chat-Widget",
  previous_aria_label: "Zurück",
  next_aria_label: "Weiter",
  attachment_alt: "Anhang",
  assistant_icon_alt: "Assistentensymbol",
  bot_avatar_alt: "Avatar des Assistenten",
  video_label: "Video {n}",
  open_content: "Inhalte öffnen",
  book_now: "Jetzt buchen",
  // Inline link chips in a message (CustomLinkRenderer): shown next to the
  // address/number the assistant wrote, and used as the accessible label.
  send_email: "E-Mail schreiben",
  call_now: "Anrufen",
  whatsapp_chat: "Auf WhatsApp schreiben",
  open_link: "Link öffnen",
  discover_hotel: "Hotel entdecken",
  discover_offer: "Angebot entdecken",
  quick_quote: "Angebot anfragen",
  view_hotel_photos: "Hotelfotos ansehen",
  view_photos: "Fotos ansehen",
  hotel_gallery: "Hotel",
  restaurant_gallery: "Restaurant",
  animation_gallery: "Animation",
  rooms_gallery: "Zimmer",
  look_hotel_galleries: "Weitere Galerien des Hotels ansehen:",
  back_to_chat: "Zurück zum Chat",
  carousel_open: "Öffnen",
  carousel_close: "Schließen",
  available: "Verfügbar",
  expand_view: "Vollansicht",
  read_more: "Mehr lesen",
  explore: "Erkunden",
  photo: "Foto",
  from_price: "ab",
  rates: "Preise",
  quote_group: {
    title: "Ihr Angebot",
    total: "Gesamt",
    room: "Zimmer {n}",
    other_options: "Weitere Optionen",
    rooms: "{n} Zimmer",
    adult: "Erwachsener",
    adults: "Erwachsene",
    child: "Kind",
    children: "Kinder",
  },
  anchor_rooms: "Unsere Angebote",
  anchor_discover: "Entdecken",
  anchor_places: "Lage & Umgebung",
  anchor_videos: "Videos",
  videos: "Videos",
  watch_video: "Video ansehen",
  feedback_useful: "Hilfreiche Antwort",
  feedback_not_useful: "Wenig hilfreich",
  proposal: "Angebot",
  proposals: "Angebote",
  contents: "Inhalte",
  places: "Orte",
  explore_title: "Ihr Aufenthalt",
  explore_rooms: "Zimmer & Preise",
  explore_discover: "Entdecken",
  explore_videos: "Videos",
  explore_places: "Orte",
  directions: "Anfahrt",
  minimize_view: "Verkleinern",

  // 1x6 P2-d-M · interactive concierge map (poi_map / itinerary templates).
  anchor_itinerary: "Ihre Route",
  itinerary: "Route",
  stops: "Stopps",
  stop: "Stopp",
  walk_min: "Min. zu Fuß",
  itinerary_start: "Startpunkt",
  your_hotel: "Ihr Hotel",
  explore_itineraries: "Routen",
  map_loading: "Karte wird geladen…",
  cat_restaurant: "Essen & Trinken",
  cat_attraction: "Sehenswürdigkeiten",
  cat_beach: "Strände",
  cat_essential: "Wichtiges",
  cat_event: "Veranstaltungen",
  cat_place: "Ort",
  reviews: "Bewertungen",

  booking: {
    choose_rate: "Tarif wählen",
    your_details: "Ihre Daten",
    review: "Übersicht",
    notes: "Anmerkungen oder Wünsche",
    notes_placeholder: "Allergien, Ankunftszeit, Kinderbett…",
    privacy: "Ich habe die Datenschutzerklärung gelesen und akzeptiere sie.",
    marketing: "Ich möchte Angebote und Neuigkeiten des Hotels erhalten.",
    privacy_required:
      "Für die Fortsetzung ist die Datenschutzeinwilligung erforderlich.",
    continue: "Weiter",
    back: "Zurück",
    confirm: "Buchung bestätigen",
    submitting: "Einen Moment…",
    cancel: "Abbrechen",
    close: "Schließen",
    retry: "Erneut versuchen",
    total: "Gesamt",
    cheapest: "Günstigster Preis",
    per_night: "pro Nacht",
    no_payment_now: "Jetzt keine Zahlung",
    nights: "Nächte",
    guests: "Gäste",
    reference: "Referenz",
    success_title: "Buchung bestätigt",
    success_body: "Sie erhalten Ihre Bestätigung in Kürze per E-Mail.",
    error_title: "Das hat nicht geklappt",
    error_body:
      "Wir konnten die Buchung nicht abschließen. Bitte versuchen Sie es gleich noch einmal.",
    mock_notice: "Testmodus: Es wurde keine echte Buchung erstellt.",
  },
};

export default de;
